import ConnUrls from "../Connections/ConnectURL";

//פונקציה טהורה - לא תלויה ב-window/document, כדי שתעבוד גם בדפדפן (MasterHeads.js) וגם בסקריפט build ב-Node (generateStaticPages.js)
const buildLocalBusinessSchema = (master, siteUrl) => {
    if (!master?.seoBusinessName && !master?.mainTitle) return null;

    let schema = {
        "@context": "https://schema.org/",
        "@type": "Restaurant",
        "name": master.seoBusinessName || master.mainTitle,
        "url": siteUrl,
    };

    if (master.seoMainImage) {
        schema.image = `${ConnUrls.servMediasUrl}/${master.seoMainImage}`;
    }
    if (master.seoPhone) {
        schema.telephone = master.seoPhone;
    }
    if (master.seoEmail) {
        schema.email = master.seoEmail;
    }
    if (master.seoStreetAddress || master.seoCity) {
        schema.address = {
            "@type": "PostalAddress",
            "streetAddress": master.seoStreetAddress || "",
            "addressLocality": master.seoCity || "",
            "addressCountry": "IL"
        };
        if (master.seoZip) {
            schema.address.postalCode = master.seoZip;
        }
    }
    if (master.seoCuisineType) {
        schema.servesCuisine = master.seoCuisineType;
    }
    if (master.seoPriceRange) {
        schema.priceRange = master.seoPriceRange;
    }
    if (master.OpeningHours?.length > 0) {
        let hoursSpec = master.OpeningHours
            .filter(h => h.Day && h.Open && h.Close)
            .map(h => ({
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": [h.Day],
                "opens": h.Open,
                "closes": h.Close,
            }));
        if (hoursSpec.length > 0) {
            schema.openingHoursSpecification = hoursSpec;
        }
    }

    let sameAs = [master.seoFacebookUrl, master.seoInstagramUrl, master.seoGoogleMapsUrl].filter(Boolean);
    if (sameAs.length > 0) {
        schema.sameAs = sameAs;
    }

    return schema;
}

export default buildLocalBusinessSchema;
